import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicModalService } from '../../../../../../../core/services/dynamic-modal.service';

@Component({
  selector: 'app-repeated-voucher-action-modal',
  templateUrl: './repeated-voucher-action-modal.component.html',
  styleUrl: './repeated-voucher-action-modal.component.scss',
})
export class RepeatedVoucherActionModalComponent {
  public message =
    'Se detectó un comprobante repetido. Selecciona cómo deseas continuar.';

  constructor(
    private activeModal: NgbActiveModal,
    private dynamicModalService: DynamicModalService,
  ) {
    const modalData = this.dynamicModalService.getModalData();
    if (modalData?.message) {
      this.message = modalData.message;
    }
  }

  rejectRequest(): void {
    this.activeModal.close({ action: 'reject' });
  }

  continueProcess(): void {
    this.activeModal.close({ action: 'continue' });
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}
